import { useState } from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { topProductMap } from '@/data/ecocreditsday';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');

const TopProductItem = ({ data }: any) => {
    const { t } = useLang('ecocreditsday.pageTabs.tabC');
    const [index, setIndex] = useState(0);

    return (
        <div className="item-box">
            <div
                className="product-img"
                onClick={() => {
                    window.open(data[index].link);
                }}
            >
                <EFPic name={data[index]?.img || []} />
            </div>
            <div className="off">{data[index]?.percent || ''}</div>
            <div className="desc">{data[index]?.desc || ''}</div>
            <div className="item-content">
                <div className="title">{data[index]?.name || ''}</div>
                <div className="limit-text">{t('product.limit')}</div>
                <div className="price-box">
                    <span className="base-price">{`${t('product.unit')}${data[index]?.limitPrice || 0}`}</span>
                    <span className="taxes-base">{t('product.taxes')}</span>
                    <span className="limit-price">{`${t('product.unit')}${data[index]?.price || 0}`}</span>
                    <span className="taxes-limit">{t('product.taxes')}</span>
                </div>
                <div className="btn-tab">
                    <div className={`common-tab__btn ${index === 0 ? 'active' : ''}`} onClick={() => setIndex(0)}>
                        {data[0]?.btnName || ''}
                    </div>
                    <div className={`common-tab__btn ${index === 1 ? 'active' : ''}`} onClick={() => setIndex(1)}>
                        {data[1]?.btnName || ''}
                    </div>
                </div>
                <div className="link-btn">
                    <div
                        className="link-common left-link"
                        onClick={() => {
                            window.open(data[0].link);
                        }}
                    >
                        <div className="link-svg"></div>
                        <div className="left-link__text">{t('product.btn1')}</div>
                    </div>
                    <div
                        className="link-common right-link"
                        onClick={() => {
                            const url = `https://jp.ecoflow.com/cart/${data[index].productId}:1?channel=buy_button`;
                            window.open(url);
                        }}
                    >
                        {t('product.btn2')}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default function TopProduct() {
    const { t } = useLang('ecocreditsday.pageTabs.tabC');
    const { locale } = useRouter();
    const productData = topProductMap[locale as keyof typeof topProductMap] || topProductMap.jp;

    return (
        <div className={styles.topProduct}>
            <div className="top-product">
                <div className="top-product__title">{t('product.title')}</div>
                <div className="top-product__box">
                    {productData?.map((item: any, index: number) => (
                        <TopProductItem key={index} data={item} />
                    ))}
                </div>
            </div>
        </div>
    );
}
